import { track, trackEvent } from '@fff-web/fff-analytics';
import { getUUID } from './uuid';
import {
  ACQUISITION_COMPLETED,
  FORM_ELEMENT_CLICKED,
  FORM_ENTRY,
  PURCHASE_PRODUCT_TYPE,
} from './constants';
import { EPayContext, IFormChangeEvent } from '../../interfaces';

const trackAquisitionCompleted = (
  sku: string | undefined,
  statusMessage: string,
  paymentType: string,
  payContext: EPayContext,
) => {
  track({
    trackName: ACQUISITION_COMPLETED,
    properties: {
      type: PURCHASE_PRODUCT_TYPE[payContext],
      cta_name: 'ORDER THE BOX',
      sku: sku || null,
      status: statusMessage,
      payment_type: paymentType,
    },
    options: {
      Optimizely: {
        userId: getUUID(payContext),
      },
    },
  });
};

const handleTrackInput = (event: IFormChangeEvent) => {
  trackEvent({
    ctaName: FORM_ELEMENT_CLICKED,
    properties: {
      Element_Name: FORM_ENTRY,
      Option_title: event?.currentTarget?.name,
      pageTitle: document.title,
    },
  });
};

const handleTrackEmailInput = () => {
  trackEvent({ ctaName: 'Input Email' });
};

export { trackAquisitionCompleted, handleTrackInput, handleTrackEmailInput };
